import {defineStore} from 'pinia';

declare global {
    var GalleryImages: string[];
}

interface State {
    images: string[];
    currentIndex: number;
}

export const useStore = defineStore('global', {
    state: () => ({
        images: window.GalleryImages,
        currentIndex: 0,
    } as State),
    getters: {
        currentImage(state) {
            return state.images[state.currentIndex];
        }
    },
    actions: {
        showImage(index:number) {
            this.currentIndex = index;
        },
        nextImage() {
            this.currentIndex = (this.currentIndex + 1) % this.images.length;
        },
        prevImage() {
            this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        }
    },
});
